<template>
  <div class="part-2-fields">
    <template v-if="corporate">
      <h5
        style="
          font-weight: bold;
          font-size: 18px;
          line-height: 26px;
          color: #231f1f;
          margin: 0 0 24px;
        "
      >
        Organization details
      </h5>

      <b-form-group>
        <b-input-group>
          <b-input-group-prepend is-text
            ><span>UEN (Optional)</span></b-input-group-prepend
          >
          <b-input
            placeholder="UEN (Optional)"
            v-model="checkout.Corporate_UEN"
          />
          <b-input-group-append>
            <b-button variant="primary" @click="check_uen"
              >Retrieve Info</b-button
            >
          </b-input-group-append>
        </b-input-group>
        <template v-slot:description>
          Data provided by data.gov.sg under the
          <a href="https://data.gov.sg/open-data-licence" target="_blank"
            >Singapore Open Data License</a
          >
        </template>
      </b-form-group>
      <hr />
      <b-form-row>
        <b-col md="12"
          ><b-form-group>
            <b-input-group
              ><b-input-group-prepend is-text
                ><span class="required"
                  >Registered company name</span
                ></b-input-group-prepend
              ><b-input
                placeholder="Registered Company Name"
                v-model="checkout.Organisation_Name"
                required
            /></b-input-group> </b-form-group
        ></b-col>
        <b-col lg="3" md="6"
          ><b-form-group
            ><b-input-group
              ><b-input-group-prepend is-text
                ><span class="required">Country</span></b-input-group-prepend
              >
              <div style="flex-grow: 1">
                <v-select
                  v-model="checkout.Donor_Address_Country"
                  :options="countryList"
                  placeholder="Country"
                  :clearable="false"
                /></div></b-input-group></b-form-group
        ></b-col>
        <b-col lg="3" md="6"
          ><b-form-group
            ><b-input-group
              ><b-input-group-prepend is-text
                ><span class="required"
                  >Postal code</span
                ></b-input-group-prepend
              ><b-input
                placeholder="Postal Code"
                v-model="checkout.Donor_Address_Postal_Code"
                required /></b-input-group></b-form-group
        ></b-col>
      </b-form-row>
      <b-form-group
        ><b-input-group
          ><b-input-group-prepend is-text
            ><span class="required">Address Line 1</span></b-input-group-prepend
          ><b-input
            v-model="checkout.Donor_Address_Line_1"
            placeholder="Address Line 1"
            required /></b-input-group
      ></b-form-group>
      <b-form-group
        ><b-input-group
          ><b-input-group-prepend is-text
            ><span>Address Line 2</span></b-input-group-prepend
          ><b-input
            v-model="checkout.Donor_Address_Line_2"
            placeholder="Address Line 2" /></b-input-group
      ></b-form-group>
      <hr />
    </template>
    <h5
      v-if="corporate"
      style="
        font-weight: bold;
        font-size: 18px;
        line-height: 26px;
        color: #231f1f;
        margin: 32px 0 24px;
      "
    >
      Main Contact person details
    </h5>

    <b-form-row>
      <b-col md="2">
        <b-form-group>
          <b-input-group class="title">
            <b-input-group-prepend is-text
              ><span class="required">Select Title</span></b-input-group-prepend
            >
            <div class="position-relative flex-grow-1">
              <input
                type="text"
                required
                :value="checkout.Title"
                class="pseudo-input"
                autocomplete="pseudo-input"
                name="pseudo-input"
              />
              <v-select
                v-model="checkout.Title"
                :options="[`Mr`, `Mrs`, `Ms`, `Dr`, `Prof`]"
                placeholder="Title"
                :searchable="false"
                :clearable="false"
              />
            </div>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="5"
        ><b-form-group
          ><b-input-group
            ><b-input-group-prepend is-text>
              <span class="required">First name</span>
            </b-input-group-prepend>
            <b-input
              placeholder="First Name"
              v-model="checkout.First_Name"
              required /></b-input-group></b-form-group
      ></b-col>
      <b-col md="5"
        ><b-form-group
          ><b-input-group
            ><b-input-group-prepend is-text
              ><span class="required">Last name</span></b-input-group-prepend
            ><b-input
              placeholder="Last Name"
              v-model="checkout.Last_Name"
              required /></b-input-group></b-form-group
      ></b-col>
    </b-form-row>
    <b-form-row>
      <b-col md="7"
        ><b-form-group
          ><b-input-group
            ><b-input-group-prepend is-text
              ><span class="required">Email</span></b-input-group-prepend
            ><b-input
              placeholder="Email Address"
              v-model="checkout.Donor_Email"
              required /></b-input-group></b-form-group
      ></b-col>
      <b-col md="5"
        ><b-form-group
          ><b-input-group
            ><b-input-group-prepend is-text
              ><span class="required">Phone number</span></b-input-group-prepend
            ><b-input
              placeholder="Phone Number"
              v-model="checkout.Donor_Phone"
              :formatter="telformat"
              lazy-formatter
              required /></b-input-group></b-form-group
      ></b-col>
    </b-form-row>
    <template v-if="!corporate">
      <b-form-row>
        <b-col md="6"
          ><b-form-group
            ><b-input-group
              ><b-input-group-prepend is-text
                ><span class="required">Country</span></b-input-group-prepend
              >
              <div style="flex-grow: 1">
                <v-select
                  v-model="checkout.Donor_Address_Country"
                  :options="countryList"
                  placeholder="Country"
                  :clearable="false"
                /></div></b-input-group></b-form-group
        ></b-col>
        <b-col md="6"
          ><b-form-group
            ><b-input-group
              ><b-input-group-prepend is-text
                ><span class="required"
                  >Postal code</span
                ></b-input-group-prepend
              ><b-input
                placeholder="Postal Code"
                v-model="checkout.Donor_Address_Postal_Code"
                required /></b-input-group></b-form-group
        ></b-col>
      </b-form-row>
      <b-form-group
        ><b-input-group
          ><b-input-group-prepend is-text
            ><span class="required">Address Line 1</span></b-input-group-prepend
          ><b-input
            v-model="checkout.Donor_Address_Line_1"
            placeholder="Address Line 1"
            required /></b-input-group
      ></b-form-group>
      <b-form-group
        ><b-input-group
          ><b-input-group-prepend is-text
            ><span>Address Line 2</span></b-input-group-prepend
          ><b-input
            v-model="checkout.Donor_Address_Line_2"
            placeholder="Address Line 2" /></b-input-group
      ></b-form-group>
    </template>
    <template v-else>
      <b-form-group
        ><b-input-group
          ><b-input-group-prepend is-text
            ><span class="required"
              >Role/Position in organisation</span
            ></b-input-group-prepend
          ><b-input
            v-model="checkout.Corporate_Position"
            placeholder="Position in Organisation"
            required /></b-input-group
      ></b-form-group>

      <b-button
        block
        @click="add_representatives"
        style="
          display: flex;
          align-items: center;
          font-weight: normal;
          font-size: 14px;
          line-height: 22px;
          color: #8c0303;
          text-align: left;
          padding: 0;
          background: transparent;
          border: 0;
        "
      >
        <span style="margin-right: 2px; display: block">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.33331 7.33301V4.66634H8.66665V7.33301H11.3333V8.66634H8.66665V11.333H7.33331V8.66634H4.66665V7.33301H7.33331ZM7.99998 14.6663C4.31798 14.6663 1.33331 11.6817 1.33331 7.99967C1.33331 4.31767 4.31798 1.33301 7.99998 1.33301C11.682 1.33301 14.6666 4.31767 14.6666 7.99967C14.6666 11.6817 11.682 14.6663 7.99998 14.6663ZM7.99998 13.333C9.41447 13.333 10.771 12.7711 11.7712 11.7709C12.7714 10.7707 13.3333 9.41416 13.3333 7.99967C13.3333 6.58519 12.7714 5.22863 11.7712 4.22844C10.771 3.22824 9.41447 2.66634 7.99998 2.66634C6.58549 2.66634 5.22894 3.22824 4.22874 4.22844C3.22855 5.22863 2.66665 6.58519 2.66665 7.99967C2.66665 9.41416 3.22855 10.7707 4.22874 11.7709C5.22894 12.7711 6.58549 13.333 7.99998 13.333Z"
              fill="#8C0303"
            />
          </svg>
        </span>
        Add Additional Representatives</b-button
      >
      <p style="font-size: 12px; line-height: 20px; color: #545454">
        (Please include at least one finance representative if the main
        representative is not in finance)
      </p>
      <b-table-simple
        :items="checkout.Corporate_Representatives"
        class="additional-representative"
      >
        <b-tbody>
          <b-tr
            v-for="(rep, dex) in checkout.Corporate_Representatives"
            :key="dex + '_corp_reps'"
          >
            <b-td
              style="
                width: 100%;
                border: 0;
                background: transparent;
                padding: 0;
              "
            >
              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  width: 100%;
                  margin: 16px 0 24px;
                "
              >
                <p
                  class="additional-title"
                  style="
                    font-weight: bold;
                    font-size: 18px;
                    line-height: 26px;
                    color: #231f1f;
                    margin-bottom: 0;
                  "
                >
                  Additional Representative {{ dex + 1 }}
                </p>
                <div style="vertical-align: middle" :id="`rm_button_${dex}`">
                  <b-button
                    style="background: transparent; border: 0; padding: 0"
                    @click="rm_representatives(dex)"
                    v-b-tooltip.hover="{ container: `#rm_button_${dex}` }"
                    title="Remove Representative"
                  >
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.3334 2.99967H13.6667V4.33301H12.3334V12.9997C12.3334 13.1765 12.2631 13.3461 12.1381 13.4711C12.0131 13.5961 11.8435 13.6663 11.6667 13.6663H2.33337C2.15656 13.6663 1.98699 13.5961 1.86197 13.4711C1.73695 13.3461 1.66671 13.1765 1.66671 12.9997V4.33301H0.333374V2.99967H3.66671V0.999674C3.66671 0.822863 3.73695 0.653294 3.86197 0.52827C3.98699 0.403246 4.15656 0.333008 4.33337 0.333008H9.66671C9.84352 0.333008 10.0131 0.403246 10.1381 0.52827C10.2631 0.653294 10.3334 0.822863 10.3334 0.999674V2.99967ZM11 4.33301H3.00004V12.333H11V4.33301ZM5.00004 6.33301H6.33337V10.333H5.00004V6.33301ZM7.66671 6.33301H9.00004V10.333H7.66671V6.33301ZM5.00004 1.66634V2.99967H9.00004V1.66634H5.00004Z"
                        fill="#8C0303"
                      />
                    </svg>
                  </b-button>
                </div>
              </div>
              <b-form-row>
                <b-col md="2">
                  <b-form-group>
                    <b-input-group class="title">
                      <b-input-group-prepend is-text
                        ><span class="required"
                          >Select Title</span
                        ></b-input-group-prepend
                      >
                      <div class="position-relative flex-grow-1">
                        <input
                          type="text"
                          required
                          :value="checkout.Title"
                          class="pseudo-input"
                          autocomplete="pseudo-input"
                          name="pseudo-input"
                        />
                        <v-select
                          v-model="rep.Title"
                          :options="[`Mr`, `Mrs`, `Ms`, `Dr`, `Prof`]"
                          placeholder="Title"
                          :searchable="false"
                          :clearable="false"
                        />
                      </div>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col md="5"
                  ><b-form-group
                    ><b-input-group
                      ><b-input-group-prepend is-text
                        ><span style="font-size: 70%; line-height: 110%"
                          >First<br />Name</span
                        ></b-input-group-prepend
                      >
                      <b-input
                        placeholder="First Name"
                        v-model="rep.First_Name"
                        required /></b-input-group></b-form-group
                ></b-col>
                <b-col md="5"
                  ><b-form-group
                    ><b-input-group
                      ><b-input-group-prepend is-text
                        ><span style="font-size: 70%; line-height: 110%"
                          >Last<br />Name</span
                        ></b-input-group-prepend
                      ><b-input
                        placeholder="Last Name"
                        v-model="rep.Last_Name"
                        required /></b-input-group></b-form-group
                ></b-col>
              </b-form-row>
              <b-form-row>
                <b-col md="7"
                  ><b-form-group
                    ><b-input-group
                      ><b-input-group-prepend is-text
                        ><span>Email</span></b-input-group-prepend
                      ><b-input
                        placeholder="Email Address"
                        v-model="rep.Donor_Email"
                        required /></b-input-group></b-form-group
                ></b-col>
                <b-col md="5"
                  ><b-form-group
                    ><b-input-group
                      ><b-input-group-prepend is-text
                        ><span> Phone number</span></b-input-group-prepend
                      ><b-input
                        placeholder="Phone Number"
                        v-model="rep.Donor_Phone"
                        :formatter="telformat"
                        lazy-formatter /></b-input-group></b-form-group
                ></b-col>
              </b-form-row>
              <b-form-group
                ><b-input-group prepend="Role / Position"
                  ><b-input
                    v-model="rep.Corporate_Position"
                    placeholder="Position in Organisation"
                    required /></b-input-group
              ></b-form-group>
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
    </template>
  </div>
</template>

<script>
import countryList from "country-list";
import axios from "axios";
import debounce from "debounce";
import phone from "phone";
export default {
  name: "fields",
  props: {
    checkout: Object,
    corporate: Boolean,
  },
  computed: {
    countryList() {
      return [
        "Singapore",
        "Malaysia",
        ...countryList
          .getNames()
          .sort()
          .filter((c) => !["Singapore", "Malaysia"].includes(c)),
      ];
    },
  },
  methods: {
    add_representatives() {
      this.checkout.Corporate_Representatives.push({
        Title: "",
        First_Name: "",
        Last_Name: "",
        Donor_Email: "",
        Donor_Phone: "",
        Corporate_Position: "",
      });
    },
    rm_representatives(dex) {
      this.checkout.Corporate_Representatives.splice(dex, 1);
    },
    telformat(number) {
      if (number[0] == "+") {
        return phone(number)[0] || "";
      }
      return phone(number, "SG")[0] || "";
    },
    fetchPostal() {
      let postal = this.checkout.Donor_Address_Postal_Code;
      let url = `https://developers.onemap.sg/commonapi/search?searchVal=${postal}&returnGeom=N&getAddrDetails=Y&pageNum=1`;
      axios
        .get(url)
        .then((rsp) => {
          let { data } = rsp;
          let entry = data.results[0];
          if (entry) {
            let address = entry?.BLK_NO + " " + entry?.ROAD_NAME;
            this.checkout.Donor_Address_Line_1 = address;
            this.checkout.Donor_Address_Line_2 = "";
          }
        })
        .catch(() => {
          //do nothing if endpoint is blocked
        });
    },
    check_uen: debounce(
      function () {
        let uen = this.checkout.Corporate_UEN;

        let url = "https://data.gov.sg/api/action/datastore_search";
        let params = {
          resource_id: "39201285-b73e-487a-a971-3a12d34ab8d9", // the resource id
          limit: 1,
          filters: JSON.stringify({
            uen,
            uen_status: "R",
          }),
        };

        let extract_rsp = (rsp) => {
          let info = rsp.data.result.records[0];
          this.checkout.Organisation_Name = info.entity_name;
          this.checkout.Donor_Address_Country = "Singapore";
          this.checkout.Donor_Address_Postal_Code = info.reg_postal_code;
        };

        axios
          .get(url, { params })
          .then((rsp) => {
            extract_rsp(rsp);
          })
          .catch(() => {
            params.resource_id = "5ab68aac-91f6-4f39-9b21-698610bdf3f7";
            axios
              .get(url, { params })
              .then((rsp) => {
                extract_rsp(rsp);
              })
              .catch(() => {
                alert(
                  "Unable to automatically retrieve Organisation information."
                );
              });
          });
      },
      800,
      true
    ),
  },
  watch: {
    "checkout.Donor_Address_Postal_Code"(val) {
      if (
        this.checkout.Donor_Address_Country == "Singapore" &&
        /^\d{6}$/.test(val)
      ) {
        debounce(this.fetchPostal, 400)();
        return;
      }
    },
  },
};
</script>
